import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/folder-download.svg
 */
const IconFolderDownload: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.586 7l-2-2H4a1 1 0 00-1 1v12a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1H9.586zM8 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2H10L8 4z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.028 11.625L11.004 9h2v2.625h-1.976z"
      fill="currentColor"
    />
    <path
      d="M15.005 11.625l-3 3.375-3-3.375h6zM9 16h6v1H9v-1zM9 15v2H8v-2h1zM16 15v2h-1v-2h1z"
      fill="currentColor"
    />
  </svg>
);

export default IconFolderDownload;
